export default {
  'budgets.page.button.blankBudget': 'Orçamento em Branco',
  'budgets.page.button.blankChecklist': 'Checklist em Branco',
  'budgets.page.button.importBudget': 'Importar Orçamento',
  'budgets.list.header.company': 'Empresa',
  'budgets.list.header.budget': 'Orçamento',
  'budgets.list.header.client': 'Cliente',
  'budgets.list.header.insuranceCompany': 'Seguradora',
  'budgets.list.header.plate': 'Placa',
  'budgets.list.header.situation': 'Situação',
  'budgets.list.header.type': 'Tipo',
};
